import {
  TextArea,
  type TextareaProps,
} from "@repo/ui/components/Base/TextArea";
import { useField } from "formik";

interface FormikTextAreaProps extends TextareaProps {
  name: string;
  placeholder?: string;
}

export const FormikTextArea = (props: FormikTextAreaProps) => {
  const [field] = useField(props);
  return <TextArea {...field} {...props} />;
};
